var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdmin2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    rx: 6,
    fill: "#CBF0FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.1667 35.4066C39.2293 35.4066 43.3333 31.3025 43.3333 26.2399C43.3333 21.1773 39.2293 17.0732 34.1667 17.0732C29.1041 17.0732 25 21.1773 25 26.2399C25 31.3025 29.1041 35.4066 34.1667 35.4066Z",
    fill: "#019EDF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.1666 38.23C40.89 38.23 38.23 40.89 38.23 44.1666C38.23 47.4433 40.89 50.105 44.1666 50.105C47.4433 50.105 50.105 47.4433 50.105 44.1666C50.105 40.89 47.4433 38.23 44.1666 38.23ZM44.1666 40.73C46.0633 40.73 47.605 42.27 47.605 44.1666C47.605 46.0633 46.0633 47.605 44.1666 47.605C42.27 47.605 40.7283 46.0633 40.7283 44.1666C40.7283 42.27 42.27 40.73 44.1666 40.73Z",
    fill: "#019EDF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.417 39.4782V36.6665C45.417 35.9765 44.857 35.4165 44.167 35.4165C43.477 35.4165 42.917 35.9765 42.917 36.6665V39.4798C42.917 40.1682 43.477 40.7298 44.167 40.7298C44.857 40.7282 45.417 40.1682 45.417 39.4782Z",
    fill: "#019EDF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.917 48.853V51.6664C42.917 52.3564 43.477 52.9164 44.167 52.9164C44.857 52.9164 45.417 52.3564 45.417 51.6664V48.853C45.417 48.1647 44.857 47.6047 44.167 47.603C43.477 47.603 42.917 48.1647 42.917 48.853Z",
    fill: "#019EDF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.9684 46.5964L37.98 48.5864C37.4917 49.0731 37.4917 49.8664 37.98 50.3531C38.4667 50.8414 39.26 50.8414 39.7467 50.3531L41.7367 48.3648C42.2234 47.8764 42.2234 47.0848 41.7367 46.5964C41.2484 46.1098 40.4567 46.1098 39.9684 46.5964Z",
    fill: "#019EDF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.4787 42.9165H36.667C35.977 42.9165 35.417 43.4765 35.417 44.1665C35.417 44.8565 35.977 45.4165 36.667 45.4165H39.4787C40.1687 45.4165 40.7303 44.8565 40.7287 44.1665C40.7287 43.4765 40.1687 42.9165 39.4787 42.9165Z",
    fill: "#019EDF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.7367 39.9684L39.7467 37.98C39.26 37.4917 38.4667 37.4917 37.98 37.98C37.4917 38.4667 37.4917 39.26 37.98 39.7467L39.9684 41.7367C40.4567 42.2234 41.2484 42.2234 41.7367 41.7367C42.2234 41.2484 42.2234 40.4567 41.7367 39.9684Z",
    fill: "#019EDF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.5602 51.2599C35.6702 50.1166 35.7502 48.4583 36.8018 47.4083L37.1252 47.0833H36.6668C35.0568 47.0833 33.7502 45.7766 33.7502 44.1666C33.7502 42.5566 35.0568 41.2499 36.6668 41.2499H37.1252L36.8018 40.9249C35.7085 39.8333 35.6652 38.0849 36.6718 36.9399C35.8552 36.8766 35.0185 36.8433 34.1668 36.8433C28.6302 36.8433 23.7285 38.2283 20.6852 40.3033C18.3635 41.8866 17.0835 43.8983 17.0835 46.0099V48.4266C17.0835 49.1783 17.3818 49.8999 17.9135 50.4299C18.4452 50.9616 19.1652 51.2599 19.9168 51.2599H36.5602Z",
    fill: "#019EDF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdmin2);
export default __webpack_public_path__ + "static/media/Admin2.1ae00a9120fe4f2a974c2431f7eb4d17.svg";
export { ForwardRef as ReactComponent };